import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgValidation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M4.412 1.5a.758.758 0 0 0-.765.75v13.5c0 .414.343.75.765.75h9.176a.758.758 0 0 0 .765-.75v-9h-3.059C10.027 6.75 9 5.743 9 4.5v-3H4.412zm6.117 1.06l2.743 2.69h-1.978a.758.758 0 0 1-.765-.75V2.56zm-8.411-.31C2.118 1.007 3.145 0 4.412 0h5.353a.77.77 0 0 1 .54.22l5.353 5.25a.74.74 0 0 1 .224.53v9.75c0 1.243-1.027 2.25-2.294 2.25H4.412c-1.267 0-2.294-1.007-2.294-2.25V2.25z" }), /* @__PURE__ */ _jsx("path", { d: "M7.126 11.446a.367.367 0 0 0-.504-.033.335.335 0 0 0-.034.485l1.25 1.375a.367.367 0 0 0 .529.01l3.036-3.094a.335.335 0 0 0-.015-.486.367.367 0 0 0-.505.014l-2.766 2.819-.991-1.09z" })]
});
export default SvgValidation;
